<script setup>
import { PROFILE_BIRTH_DATE_LENGTH } from '@/constants/profile';
import { useAddProfileForm } from '@/views/profiles/ManageProfiles/composables/use-add-profile-form';

const { name, dateOfBirth, errors, updateDateOfBirth, submit, closeForm } = useAddProfileForm();
</script>

<template>
  <div class="profile-actions-container">
    <h1>{{ $t('addProfile') }}</h1>
    <h2>{{ $t('addProfileDescr') }}</h2>
    <div class="profile-metadata profile-entry">
      <div class="main-profile-avatar">
        <img src="https://media.tv4.live/bm01.png" alt="avatar" />
      </div>
      <div class="profile-add-parent">
        <div class="profile-entry-inputs">
          <div class="profile-entry-field">
            <input id="add-profile-name" v-model="name" type="text" :placeholder="$t('name')" :aria-label="$t('name')" />
            <p v-if="errors.name" class="profile-entry-error">{{ errors.name }}</p>
          </div>
          <div class="profile-entry-field">
            <input
              id="add-profile-date-of-birth"
              type="text"
              inputmode="numeric"
              autocomplete="bday"
              :value="dateOfBirth"
              :maxlength="PROFILE_BIRTH_DATE_LENGTH"
              :placeholder="$t('addProfileForm.dateOfBirthPlaceholder')"
              :aria-label="$t('addProfileForm.dateOfBirth')"
              @input="updateDateOfBirth"
            />
            <p v-if="errors.dateOfBirth" class="profile-entry-error">{{ errors.dateOfBirth }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="buttons-container">
      <button class="profile-button preferred-action" :class="{ 'preferred-active': !!name }" @click="submit">
        {{ $t('continue') }}
      </button>
      <button class="profile-button" @click="closeForm">
        {{ $t('cancel') }}
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import 'style';
</style>
